import { defineStore } from 'pinia'
import { ref } from 'vue'
import { storageLike } from "@/store/pinia.js"

export const menuStore = defineStore('menu', () => {
    const menuList = ref([])
    const tabList = ref([])
    const permissionList = ref([]);

    return {
        menuList,
        setMenuList(val = []) {
            menuList.value = val;
        },
        getMenuList() {
            return menuList.value;
        },
        tabList,
        setTabList(val = []) {
            tabList.value = val;
        },
        getTabList() {
            return tabList.value
        },
        permissionList,
        setPermission(val = []) {
            permissionList.value = val;
        },
        getPermission() {
            return permissionList.value;
        }
    }
}, {
    persist: {
        storage: storageLike
    },
})